import CircularProgress from "@material-ui/core/CircularProgress";
import GetAppIcon from "@material-ui/icons/GetApp";
import CloudSyncIcon from '@material-ui/icons/Sync';
import axios from "axios";
import { cloneElement, useState } from "react";
import {
  Button, CreateButton, sanitizeListRestProps, TopToolbar
} from "react-admin";

const ListActions = (props) => {
  const { className, filters, maxResults, ...rest } = props;
  const [loading, setLoading] = useState(false);

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {cloneElement(filters, { context: "button" })}
      <CreateButton label="inserisci impianti" />
      <Button label="allineamento impianti" 
       onClick={() => {
        setLoading(true);
        axios
            .get(window.BaseURL + `/gse/aggiorna`, {
              responseType: "blob",
              headers: {
                Authorization: `Bearer ${localStorage.getItem("auth")}`,
              },
            })
            .then((response) => {             
              setLoading(false);
            })
            .catch(function (error) {
              setLoading(false);
              console.log(error);
            });
        }}
      >
        {loading ? (
          <CircularProgress size={18} thickness={5} />
        ) : (
          <CloudSyncIcon />
        )}
      </Button>
      <Button
        onClick={() => {
          setLoading(true);
          axios
            .get(window.BaseURL + `/gse/downloadAllReports`, {
              responseType: "blob",
              headers: {
                Accept: "application/pdf",
                Authorization: `Bearer ${localStorage.getItem("auth")}`,
              },
            })
            .then((response) => {
              const url = URL.createObjectURL(response.data);
              setLoading(false);
              // Creating the hyperlink and auto click it to start the download
              let link = document.createElement("a");
              link.href = url;
              const filename = response.headers["x-suggested-filename"];
              link.download = filename;
              link.click();
            })
            .catch(function (error) {
              setLoading(false);
              alert(`Non è stato possibile scaricare il file.\n${error}`);
              console.log(error);
            });
        }}
        label="Scarica tutti i report"
      >
        {loading ? (
          <CircularProgress size={18} thickness={5} />
        ) : (
          <GetAppIcon />
        )}
      </Button>
      {/* <Button
        onClick={() => {
          axios
            .get(window.BaseURL + `/dropbox/oauth/start`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("auth")}`,
              },
            })
            .then((response) => {
              const url = response;
              window.open(url.data);
            })
            .catch(function (error) {
              alert(`Errore:\n${error}`);
              console.log(error);
            });
        }}
        label="Autenticazione Dropbox"
      /> */}
    </TopToolbar>
  );
};

export default ListActions;
